import { getToken } from "../cookie/authCookie";
import  axiosInstance  from "./config/axiosConfigs";


export const PayoutAPI = {

  postAdminOnBoarding: async function (onBoardingAccountMgmt) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payout/admin/on-boarding`,
      method: "POST",
      withCredentials: true,
      timeout: 5000, 
      data: onBoardingAccountMgmt,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postAdminPayoutSetup: async function (adminPayoutOnBoarding) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payout/admin/setup`,
      method: "POST",
      withCredentials: true,
      timeout: 5000, 
      data: adminPayoutOnBoarding,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postIsUserAdminVerified: async function (isUserAdminVerified) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payout/admin/is-user-verified`,
      method: "POST",
      withCredentials: true,
      // timeout: 5000, 
      data: isUserAdminVerified,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

  postAdminOnBoardingCheckDoc: async function (adminAccontDueInfo) {

    const response = await axiosInstance.request({
      url: `/ecommerce/payout/admin/on-boarding/check-doc`,
      method: "POST",
      withCredentials: true,
      timeout: 5000, 
      data: adminAccontDueInfo,
      headers: { Authorization: `Bearer ${getToken()}` },
    });
    return response.data;
  },

};